// Mutation hook for DELETE /api/sites/:siteId/comms/channels/:channelId.
//
// The server soft-deletes the channel (sets deletedAt) and it disappears from
// all members' channel lists on their next fetch. No WS broadcast is needed —
// the sender navigates away immediately and other members see the change on
// their next channels refetch (or when their next message send fails).

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useClientApis } from '../../hooks/ClientApisProvider.js';
import { commsKeys } from '../queryKeys.js';

export function useDeleteChannel(siteId: string) {
  const { deleteChannel } = useClientApis().comms;
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (channelId: string) => deleteChannel(siteId, channelId),
    onSuccess: () => {
      // Invalidate the channels list so the deleted channel drops from the
      // sidebar without requiring a manual refresh.
      void queryClient.invalidateQueries({ queryKey: commsKeys.channels(siteId) });
    },
  });
}
